

// import React from "react";
// import styled from "styled-components";
// import footimage from "../Assets/Sultlog2.png";
// import { FaInstagram } from "react-icons/fa";
// import { FaFacebook } from "react-icons/fa";
// import { FaWhatsapp } from "react-icons/fa";
// import { FaTwitter } from "react-icons/fa";
// import { AiOutlineCopyright } from "react-icons/ai";

// const Wrap = styled.div`
//   width: 100%;
//   height: 100%;
//   box-sizing: border-box;
// `;
// const ContanierFoot = styled.div`
//   color: white;
//   background-color: #171764;
//   height: 350px;
//   box-sizing: border-box;
//   width: 100%;
//   @media screen and (max-width: 600px) {
//     height: 800px;
//   }
//   @media screen and (min-width: 601px) and (max-width: 849px) {
//     height: 970px;
//   }
//   @media screen and (min-width: 850px) and (max-width: 1100px) {
//     height: 500px;
//   }
// `;
// const ContanierLogo = styled.div`
//   width: 100%;
//   height: 70px;
// `;
// const ContanierColum = styled.div`
//   width: 100%;
//   padding-left: 140px;
//   margin-top: 10px;
//   height: 260px;
//   display: flex;
//   gap: 10px;
//   box-sizing: border-box;
//   @media screen and (max-width: 600px) {
//     display: flex;
//     flex-direction: column;
//     padding: 0px;
//     height: 690px;
//     gap: 0px;
//   }
//   @media screen and (min-width: 601px) and (max-width: 849px) {
//     display: flex;
//     flex-direction: column;
//     padding: 0px;
//     height: 880px;
//     gap: 0px;
//   }
//   @media screen and (min-width: 850px) and (max-width: 1100px) {
//     padding: 10px;
//     height: 400px;
//     padding-left: 30px;
//     padding-top: 50px;
//     margin-top: 30px;
//   }
// `;
// const ContanierOne = styled.div`
//   color: white;
//   width: 30%;
//   margin-top: 10px;
//   @media screen and (max-width: 600px) {
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     text-align: center;
//     margin-top: 40px;
//     line-height: 25px;
//     width: 100%;
//   }
//   @media screen and (min-width: 601px) and (max-width: 849px) {
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     text-align: center;
//     width: 100%;
//   }
//   @media screen and (min-width: 850px) and (max-width: 1100px) {
//     width: 33%;
//     height: auto;
//   }
// `;
// const ContanierTwo = styled.div`
//   width: 30%;
//   margin-top: 7px;
//   color: white;
//   padding: 15px;
//   padding-left: 70px;
//   @media screen and (max-width: 600px) {
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     padding-left: 10px;
//     align-items: center;
//     text-align: center;
//     padding-bottom: 0px;
//   }
//   @media screen and (min-width: 601px) and (max-width: 849px) {
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     padding-left: 10px;
//     align-items: center;
//     text-align: center;
//     padding-bottom: 0px;
//   }
//   @media screen and (min-width: 850px) and (max-width: 1100px) {
//   }
// `;
// const ContanierThree = styled.div`
//   width: 30%;
//   margin-top: 10px;
//   color: white;
//   @media screen and (max-width: 600px) {
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     align-items: center;
//     text-align: center;
//     padding-top: 0px;
//     line-height: 22px;
//   }
//   @media screen and (min-width: 601px) and (max-width: 849px) {
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     align-items: center;
//     text-align: center;
//     padding-top: 0px;
//     line-height: 22px;
//   }
//   @media screen and (min-width: 850px) and (max-width: 1100px) {
//     width: 40%;
//   }
// `;
// const FoorImage = styled.img`
//   width: 150px;
//   height: 150px;
//   padding-top: 15px;
//   margin-left: 140px;

//   @media screen and (max-width: 600px) {
//     text-align: center;
//     width: 150px;
//     height: 150px;
//     justify-content: center;
    
//   }
//   @media screen and (min-width: 601px) and (max-width: 849px) {
//     margin-left: 30px;
//     margin-top: 30px;
//   }
//   @media screen and (min-width: 850px) and (max-width: 1100px) {
//     margin-left: 30px;
//     margin-top: 30px;
//   }
// `;
// const HeadText = styled.h1`
//   font-size: 1.3rem;
//   margin: 10px;
//   @media screen and (max-width: 600px) {
//     font-size: 1rem;
//     margin: 0px;
//     margin-top: 8px;
//   }
// `;
// const ParaText = styled.p`
//   font-size: 1rem;
//   margin: 10px;
//   @media screen and (max-width: 600px) {
//     font-size: 1rem;
//     margin: 0px;
//     line-height: 35px;
//   }
// `;
// const HeadText1 = styled.h1`
//   font-size: 1.7rem;
//   color: #e9b60f;
//   @media screen and (max-width: 600px) {
//     margin-left: 30px;
//     margin-top: 30px;
//   }
// `;

// const InstagramIcon = styled(FaInstagram)`
//   color: #fdfcfc; /* Instagram brand color */
//   font-size: 2rem; /* Adjust the size as needed */
//   transition: color 0.3s ease;

//   &:hover {
//     color: #e1306c; /* Change color on hover */
//     background-color: white;
//   }
//   @media screen and (max-width: 600px) {
//     display: flex;
//   }
// `;

// const FacebookIcon = styled(FaFacebook)`
//   color: #fafafa; /* Facebook brand color */
//   font-size: 2rem; /* Adjust the size as needed */
//   transition: color 0.3s ease;

//   &:hover {
//     background-color: white;
//     color: #1877f2; /* Change color on hover */
//   }
// `;
// const WhatsappIcon = styled(FaWhatsapp)`
//   color: #25d366; /* WhatsApp brand color */
//   font-size: 2rem; /* Adjust the size as needed */
//   transition: color 0.3s ease;

//   &:hover {
//     background-color: white;
//     color: #25d366; /* Change color on hover */
//   }
// `;


// const Icons = styled.div`
//   display: flex;
//   gap: 20px;
//   @media screen and (max-width: 849px) {
//     display: none;
//   }
// `;
// const Icons1 = styled.div`
//   display: flex;
//   gap: 20px;
//   @media screen and (max-width: 850px) {
//     display: flex;
//     margin: 20px;
//   }
//   @media screen and (min-width: 851px) {
//     display: none;
//   }
// `;

// const Contanier1Foot2 = styled.p`
//   width: 100%;
//   height: 70px;
//   align-items: center;
//   text-align: center;
//   justify-content: center;
//   display: flex;
//   background-color: black;
//   color: white;
//   @media screen and (max-width: 600px) {
//     font-size: 8px;
//   }
// `;
// const HeadUnderLine = styled.p`
//   text-decoration: underline;
// `;

// const IconsLinks = styled.a``;

// const Footer = () => {
  
//   return (
//     <>
//       <Wrap>
//         <ContanierFoot>
//           <ContanierLogo>
//             <FoorImage src={footimage} alt="Foot Image Not Found" />
//             {/* <FooterContainer> */}
//             {/* <ScrollButton onClick={handleScrollToNavbar}><IoMdNavigate /></ScrollButton> */}
//             {/* </FooterContainer> */}
//           </ContanierLogo>
//           <ContanierColum>
//             <ContanierOne>
              
//               <HeadText>
//                 We Offer Amazon’s Best & Hottest Deals. Anybody can locate what
//                 they need.
//               </HeadText>
//             </ContanierOne>
//             <ContanierTwo>
//               <HeadText>Home</HeadText>
//               <HeadText>About Us</HeadText>
//               <HeadText>Services</HeadText>
//               <HeadText>Blog</HeadText>
//               <HeadText>Contect Us</HeadText>
//               <HeadText1>Follow Us</HeadText1>
//               <Icons1>
//                 <IconsLinks
//                   href=" https://www.instagram.com/sultan41642?igsh=YzljYTk1ODg3Zg=="
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <InstagramIcon />
//                 </IconsLinks>

//                 <IconsLinks
//                   href="https://wa.me/message/7FF2GU7MVGA5P1"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <WhatsappIcon />
//                 </IconsLinks>

//                 <IconsLinks
//                   href="https://x.com/AmazoneGifts?t=NYdXOkhRbJD1BVaNxoZnNA&s=09"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <FaTwitter />
//                 </IconsLinks>

//                 <IconsLinks
//                   href="https://www.facebook.com/profile.php?id=100069755324952&mibextid=ZbWKwL"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <FacebookIcon />
//                 </IconsLinks>
//               </Icons1>
//             </ContanierTwo>
//             <ContanierThree>
//               <HeadText>Amazon Disclosure:</HeadText>
//               <br></br>
//               <ParaText>
//                 {" "}
//                 <b>
//                   The TopDealHub19 is a partner in the Amazon Associates
//                   Program. We are the sole Amazon Affiliate Program commission
//                   earners.
//                 </b>
//               </ParaText>
//               <Icons>
//                 <IconsLinks
//                   href="  https://www.instagram.com/sultan41642?igsh=YzljYTk1ODg3Zg=="
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <InstagramIcon />
//                 </IconsLinks>

//                 <IconsLinks
//                   href="https://wa.me/message/7FF2GU7MVGA5P1"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <WhatsappIcon />
//                 </IconsLinks>

//                 <IconsLinks
//                   href="https://x.com/AmazoneGifts?t=NYdXOkhRbJD1BVaNxoZnNA&s=09"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <FaTwitter />
//                 </IconsLinks>

//                 <IconsLinks
//                   href="https://www.facebook.com/profile.php?id=100069755324952&mibextid=ZbWKwL"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   <FacebookIcon />
//                 </IconsLinks>
//               </Icons>
//             </ContanierThree>
//           </ContanierColum>
//         </ContanierFoot>
//         <Contanier1Foot2>
//           Copyright <AiOutlineCopyright /> &nbsp; 2022 Developed by &nbsp;{" "}
//           <HeadUnderLine> sultankhanmayo04@gmail.com</HeadUnderLine>. &nbsp; All
//           Rights Reserved.
//         </Contanier1Foot2>
//       </Wrap>
//     </>
//   );
// };

// export default Footer;


import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTwitter, FaWhatsapp } from "react-icons/fa";

const FooterContainer = styled.footer`
  background: #02417cff;
  color: #fff;
  text-align: center;
  padding: 40px 20px;
  margin-top: 50px;
`;

const FooterLinks = styled.div`
  margin: 20px 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap; /* small screen pe links wrap ho jayein */

  a {
    color: #ddd;
    margin: 8px 15px;
    text-decoration: none;
    font-size: 0.95rem;
    transition: color 0.3s ease;

    &.active {
      color: #ff9900; /* Active link Amazon orange */
      font-weight: bold;
    }

    &:hover {
      color: #ff9900;
    }
  }

  /* Tablet view */
  @media (max-width: 768px) {
    a {
      font-size: 0.9rem;
      margin: 6px 12px;
    }
  }

  /* Mobile view */
  @media (max-width: 480px) {
    flex-direction: column; /* links neeche neeche aa jayein */
    align-items: center;

    a {
      margin: 8px 0;
      font-size: 0.85rem;
    }
  }
`;


const SocialIcons = styled.div`
  margin: 20px 0;

  a {
    margin: 0 10px;
    font-size: 1.5rem;
    color: #ddd;

    &:hover {
      color: #ff9900;
    }
  }
`;

const Disclaimer = styled.p`
  font-size: 1rem;
  color: #bbb;
  margin-top: 20px;
  line-height: 1.5;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    padding: 0 10px; /* thoda spacing for small screens */
  }

  @media (max-width: 480px) {
    font-size: 0.7rem;
    line-height: 1.4;
    padding: 0 5px;
  }
`;

const CopyRight = styled.p`
  margin-top: 10px;
  font-size: 0.9rem;
  color: #888;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }

  @media (max-width: 480px) {
    font-size: 0.75rem;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterLinks>
        <NavLink to="/" end>Home</NavLink>
        <NavLink to="/aboutus">About Us</NavLink>
        <NavLink to="/products">Products</NavLink>
        <NavLink to="/privacy-policy">Privacy Policy</NavLink>
        <NavLink to="/terms-and-conditions">Terms & Conditions</NavLink>
        <NavLink to="/affiliate-disclosure">Affiliate Disclosure</NavLink>
        <NavLink to="/contactus">Contact</NavLink>
      </FooterLinks>

      <SocialIcons>
        <a href="https://www.facebook.com/share/1Bb97egod4/"><FaFacebook /></a>
        <a href="https://www.instagram.com"><FaInstagram /></a>
        <a href="#"><FaTwitter /></a>
        <a href="https://wa.me/qr/QYMILJT4IT3BG1"><FaWhatsapp /></a>
      </SocialIcons>

      <Disclaimer>
        As an Amazon Associate, we earn from qualifying purchases.  
        This website participates in the Amazon Services LLC Associates Program, 
        an affiliate advertising program designed to provide a means for sites to 
        earn advertising fees by advertising and linking to Amazon.com.
      </Disclaimer>

      <CopyRight>
        © {new Date().getFullYear()} SmartZoDeals | All Rights Reserved
      </CopyRight>
    </FooterContainer>
  );
};

export default Footer;

